import React from 'react';
import { Description as DescriptionIcon } from '@material-ui/icons';

import { FetchError } from '../../../common/api/api';
import Card from '../../../common/card/Card';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineTextField from '../../../common/inline/InlineTextField';
import { OrganizationInfo } from '../Organization.interface';

export interface OrganizationInfoCardProps {
  value?: OrganizationInfo;
  isLoading?: boolean;
  error?: FetchError;
}

const OrganizationInfoCard: React.FC<OrganizationInfoCardProps> = props => {
  const { value, isLoading, error } = props;
  return (
    <Card>
      <CardTitle>
        <DescriptionIcon />
        Organization Info
      </CardTitle>
      <CardContent padding='large'>
        <InlineFormik
          error={error}
          isSubmitting={isLoading}
          initialValues={{
            clientId: value?.clientId || '',
            clientSecret: value?.clientSecret || ''
          }}
          onSubmit={() => {
            // ignore submit
          }}
        >
          <InlineForm>
            <InlineTextField
              name='clientId'
              label='Client ID'
              inputProps={{ readOnly: true }}
            />
            <InlineTextField
              name='clientSecret'
              label='Client Secret'
              inputProps={{ readOnly: true }}
            />
          </InlineForm>
        </InlineFormik>
      </CardContent>
    </Card>
  );
};

export default OrganizationInfoCard;
